import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import CollectionCalendar from "@/components/collections/calendar/collection-calendar";

// `mode` (month/week/day/agenda/timeline) y `date` (YYYY-MM-DD) ubican el
// periodo; `rows`, el campo de las filas del cronograma;
// `passthrough`: los filtros por valor de la tabla viajan en la URL.
const calendarSearchSchema = z
  .object({ search: z.string().optional(), mode: z.string().optional(), date: z.string().optional() })
  .passthrough();

export const Route = createFileRoute("/_authenticated/collections/$collectionId/calendar")({
  validateSearch: calendarSearchSchema,
  component: CollectionCalendarPage,
});

function CollectionCalendarPage() {
  const { collectionId } = Route.useParams();
  const searchParams = Route.useSearch();
  return <CollectionCalendar key={collectionId} collectionId={collectionId} searchParams={searchParams} />;
}
